import { Component, Input } from '@angular/core';

/**
 * The "nothing here" panel, replacing the `.no-data` block that had been written
 * out separately in six component stylesheets and ten templates.
 *
 * Content is projected rather than passed as strings so a caller can put a link
 * or a button in the message — several already did.
 */
@Component({
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss']
})
export class EmptyStateComponent {

  /** A Material Icons ligature name. */
  @Input() icon = 'inbox';
  @Input() title = '';
}
